import React, {useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from "react-dom";
import DateBeauty from "./component/date_beauty";
import Teacher from "./component/teacher";
import PriceShow from "./component/price_show";
import MasterPriceShow from "../masterclass_tool/component/price_show";
import MasterclassVideo from "./component/video";
import PrivateclassVideo from "./component/video";
import useResponsive from "../hooks/responsive";
import BuyMasterclassForm from "../masterclass_tool/buy_masterclass_form";
import RegisterOnline from "../tool_component/register_online";
import BuyPrivateClassForm from "./buy_privateclass_form";

export default function PrivateclassShow({hasSubscription, defaultPrivateclass, hasCard, isUser}) {
    const [loading, setLoading] = useState(false);
    const [privateclass, setPrivateClass] = useState(null)
    const [masterclass, setMasterclass] = useState(null)
    const [typeOfClass, setTypeClass] = useState(null)
    const [isMobile, maxWidthContainer] = useResponsive()
    const [isBuyingPrivateclass, setIsBuyingPrivateclass] = useState(false)
    const [isBuyingMasterclass, setIsBuyingMasterclass] = useState(false)
    const [opacity, setOpacity] = useState(opacity)

    if (!privateclass && defaultPrivateclass && defaultPrivateclass.class_type === 'PRIVATE') {
        setPrivateClass(defaultPrivateclass)
        setTypeClass(defaultPrivateclass.class_type)
    } else if (!masterclass && defaultPrivateclass && defaultPrivateclass.class_type === 'MASTER') {
        setMasterclass(defaultPrivateclass)
        setTypeClass(defaultPrivateclass.class_type)
    }

    useEffect(() => {
            if(loading) return

            setOpacity(0)
            setTimeout(() => setOpacity(1), 100)

    }, [loading])

    useEffect(() => {
        const listener = (event) => {
            const slug = event.detail

            setLoading(true)
            setIsBuyingPrivateclass(false)
            setIsBuyingMasterclass(false)

            fetch(`/ajax/privateclass/fetch/${slug}`)
                .then(r => r.json())
                .then(result => {
                    setMasterclass(null)
                    setPrivateClass(result)
                    setTypeClass('PRIVATE')
                    setLoading(false)
                })
        }

        document.addEventListener('privateclass_select', listener)

        return () => {
            document.removeEventListener('privateclass_select', listener)
        }
    }, [])

    useEffect(() => {
        const listener = (event) => {
            const slug = event.detail

            setLoading(true)
            setIsBuyingMasterclass(false)
            setIsBuyingPrivateclass(false)

            fetch(`/ajax/masterclass/fetch/${slug}`)
                .then(r => r.json())
                .then(result => {
                    setPrivateClass(null)
                    setMasterclass(result)
                    setTypeClass('MASTER')
                    setLoading(false)
                })
        }

        document.addEventListener('masterclass_select', listener)

        return () => {
            document.removeEventListener('masterclass_select', listener)
        }
    }, [])

    return(
        <Container opacity={opacity} isMobile={isMobile}>
            <LoadingContainer isLoading={loading}><img src='/images/loader.svg' /></LoadingContainer>
            {(!privateclass && !masterclass && !loading ) && (
                <NoPrivateclassContainer>
                    <ErrorMessage>Selecciona una clase para empezar</ErrorMessage>
                    <ImageNoPrivateclass isMobile={isMobile} src="/images/no_masterclass.svg" />
                </NoPrivateclassContainer>)}

            {privateclass && typeOfClass === 'PRIVATE' && !loading && (
                <DataContainer containerWidth={maxWidthContainer}>
                    <HeaderContainer>
                        <TeachderDateContainer>
                            <TeacherContainer>
                                <Teacher teacher={privateclass.teacher} big/>
                            </TeacherContainer>
                        </TeachderDateContainer>

                        <DateBeauty
                            big
                            startsDay={privateclass.start_day_label}
                            startsMonth={privateclass.start_day_month}
                            starsHour={privateclass.start_day_time}
                        />
                    </HeaderContainer>

                    <TitleDescriptionContainer>
                        {(privateclass.is_free || privateclass.is_registered || privateclass.has_space) ? (
                            <IsFreeContainer>
                                {privateclass.is_free ? (<IsFreeSpan>GRATIS</IsFreeSpan>) : null}
                                {privateclass.is_registered ? (<IsRegisteredSpan>REGISTRADO</IsRegisteredSpan>) : null}
                                {!privateclass.has_space ? (<IsRegisteredSpan>COMPLETA</IsRegisteredSpan>) : null}
                            </IsFreeContainer>) : null}

                        <Title>{privateclass.name}</Title>
                        <Description>{privateclass.description}</Description>
                    </TitleDescriptionContainer>

                    {((privateclass.is_registered || hasSubscription) && privateclass.file ) && (
                        <DownloadContainer>
                            <DownloadTitle>Recursos descargables</DownloadTitle>
                            <DownloadLink target="_blank" href={privateclass.file}><DownloadIcon src="/images/download_icon.svg" /> Descargar archivo</DownloadLink>
                        </DownloadContainer>
                    )}

                    {isUser && privateclass.class_type === 'PRIVATE' && (
                        <React.Fragment>
                            <PriceShow
                                hasCard={hasCard}
                                onBuyMasterclass={() => setIsBuyingPrivateclass(true)}
                                hasVideo={privateclass.has_video}
                                isDone={privateclass.is_done}
                                wherebyUrl={privateclass.link_whereby}
                                slug={privateclass.slug}
                                courseId={privateclass.course_id}
                                isRegistered={privateclass.is_registered}
                                isFree={privateclass.is_free}
                                isSubscribed={hasSubscription}
                                startsAt={privateclass.starts_at}
                                classDurationMinutes={privateclass.duration_minutes}
                                />
                            <BuyPrivateClassForm
                                isFree={privateclass.is_free}
                                isSubscribed={hasSubscription}
                                isActive={isBuyingPrivateclass}
                                price={privateclass.price || 18}
                                name={privateclass.name}
                                slug={privateclass.slug}
                                hasCard={hasCard}
                            />
                        </React.Fragment>
                    )}

                    {!isUser && (
                        <RegisterOnline onSuccess={() => {
                            if(privateclass.is_free && privateclass.has_space) {
                                location.href = `/buy/page/`
                            } else {
                                window.location.reload()
                            }
                        }} />
                    )}

                    {privateclass.is_registered && privateclass.has_video && (<PrivateclassVideo
                        slug={privateclass.slug}
                        video={privateclass.video}
                        hasVideo={privateclass.has_video}
                        hasSubscription={hasSubscription}
                    />)}
                </DataContainer>
            )}

            {masterclass && typeOfClass === 'MASTER'  && !loading && (
                <DataContainer containerWidth={maxWidthContainer}>
                    <HeaderContainer>

                        <TeachderDateContainer>

                            <TeacherContainer>
                                <Teacher teacher={masterclass.teacher} big/>
                            </TeacherContainer>

                        </TeachderDateContainer>

                        <DateBeauty
                            big
                            startsDay={masterclass.start_day_label}
                            startsMonth={masterclass.start_day_month}
                            starsHour={masterclass.start_day_time}
                        />


                    </HeaderContainer>

                    <TitleDescriptionContainer>
                        {(masterclass.is_free || masterclass.is_registered || masterclass.has_space) ? (
                            <IsFreeContainer>
                                {masterclass.is_free ? (<IsFreeSpan>GRATIS</IsFreeSpan>) : null}
                                {masterclass.is_registered ? (<IsRegisteredSpan>REGISTRADO</IsRegisteredSpan>) : null}
                                {!masterclass.has_space ? (<IsRegisteredSpan>COMPLETA</IsRegisteredSpan>) : null}
                            </IsFreeContainer>) : null}

                        <Title>{masterclass.name}</Title>
                        <Description>{masterclass.description}</Description>
                    </TitleDescriptionContainer>

                    {((masterclass.is_registered || hasSubscription) && masterclass.file ) && (
                        <DownloadContainer>
                            <DownloadTitle>Recursos descargables</DownloadTitle>
                            <DownloadLink target="_blank" href={masterclass.file}><DownloadIcon src="/images/download_icon.svg" /> Descargar archivo</DownloadLink>
                        </DownloadContainer>
                    )}

                    {isUser && (
                        <React.Fragment>
                            <MasterPriceShow
                                hasCard={hasCard}
                                onBuyMasterclass={() => setIsBuyingMasterclass(true)}
                                hasVideo={masterclass.has_video}
                                isDone={masterclass.is_done}
                                wherebyUrl={masterclass.link_whereby}
                                slug={masterclass.slug}
                                price={masterclass.price}
                                isRegistered={masterclass.is_registered}
                                isFree={masterclass.is_free}
                                isSubscribed={hasSubscription}
                                startsAt={masterclass.starts_at}
                                classDurationMinutes={masterclass.duration_minutes}
                                />

                            <BuyMasterclassForm
                                isFree={masterclass.is_free}
                                isSubscribed={hasSubscription}
                                isActive={isBuyingMasterclass}
                                price={masterclass.price}
                                name={masterclass.name}
                                slug={masterclass.slug}
                                hasCard={hasCard}
                            />
                        </React.Fragment>
                    )}

                    {!isUser && (
                        <RegisterOnline onSuccess={() => {
                            if(masterclass.is_free && masterclass.has_space) {
                                location.href = `/buy/masterclass/${masterclass.slug}`
                            } else {
                                window.location.reload()
                            }
                        }} />
                    )}

                    {masterclass.video && (<MasterclassVideo
                        slug={masterclass.slug}
                        video={masterclass.video}
                        hasVideo={masterclass.has_video}
                        hasSubscription={hasSubscription}
                    />)}
                </DataContainer>
            )}
        </Container>
    )
}

const IsFreeContainer = styled.div`
    padding-bottom: 12px;
    margin-bottom: 12px;
`
const IsFreeSpan = styled.span`

    font-size: 10px;
    color: white;
    font-weight: bold;
    padding: 4px;
    border-radius: 16px;
    background-color: #92AC86;
    margin-right: 18px;
`

const IsRegisteredSpan = styled.span`

    font-size: 10px;
    color: white;
    font-weight: bold;
    padding: 4px;
    border-radius: 16px;
    background-color: #090C9B;

`

const ErrorMessage = styled.div`
    color: white;
    padding-bottom: 72px;
    text-align: center;
`

const NoPrivateclassContainer = styled.div`
    padding-top: 24px;
`

const ImageNoPrivateclass =styled.img`
    width: ${props => props.isMobile ? 280 : 500}px;
    margin:auto;
`
const DownloadIcon = styled.img`
    height: 18px;
    margin-top: 4px;
`
const DownloadContainer = styled.div`
    padding-top: 48px;
    padding-bottom: 22px;
`

const DownloadTitle = styled.div`
    color: #FA9F63;
    font-size: 22px;
    padding-bottom: 12px;
`

const DownloadLink = styled.a`
    color: white;
`

const Title = styled.div`
    font-size: 22px;
    color: white;
`

const Description = styled.div`
    padding-top: 8px;
    font-size: 16px;
    line-height: 22px;
`
const TitleDescriptionContainer = styled.div`
    padding-top: 24px;
    font-size: 18px;
`

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const DataContainer = styled.div`
    width: ${props => props.containerWidth}px;
`
const TeacherContainer = styled.div`
    padding-left: 12px;
`

const TeachderDateContainer = styled.div`
    display: flex;
    flex-direction: row;
`
const Container = styled.div`
   padding: ${props => props.isMobile ? '8px' : '24px'};
   padding-top: 72px;
   padding-bottom: 450px;
   max-height: calc(100vh - 40px);
   display: flex;
   flex-direction: row;
   justify-content: center;
   width: ${props => props.isMobile ? '90vw' : '100%'};
   opacity: ${props => props.opacity};
   ${props => props.opacity == '1' ? 'transition:opacity 1s ease-in;' : ''}
`

const LoadingContainer = styled.div`
    display: ${props => props.isLoading === true ? 'flex' : 'none'};
    padding-top: 64px;
    flex-direction: row;
    justify-content: center
`

if (document.getElementsByTagName('privateclass-show-panel')) {
    const elms = document.getElementsByTagName('privateclass-show-panel')

    for(let elm of elms) {
        const hasSuscription = elm.attributes['has-suscription'].value == '1'
        const defaultPrivateclass = elm.attributes['default-privateclass'] ? JSON.parse(elm.attributes['default-privateclass'].value) : null
        const hasCard = elm.attributes['has-card'].value === '1'
        const isUser = elm.attributes['is-user'].value === '1'

        ReactDOM.render(<PrivateclassShow
            isUser={isUser}
            hasCard={hasCard}
            hasSubscription={hasSuscription}
            defaultPrivateclass={defaultPrivateclass}
        />, elm);
    }
}
